/**
 * @file
 * Contains msToTime converter util
 * If the string is in milliseconds, convert to hh:mm:ss as follows:
 * Using some recently added language features
 */

const pad = (n, z = 2) => ('00' + n).slice(-z);

export function msToTime(s) {
  // Pad to 2 or 3 digits, default is 2
  return (
    pad((s / 3.6e6) | 0) +
    ' : ' +
    pad(((s % 3.6e6) / 6e4) | 0) +
    ' : ' +
    pad(((s % 6e4) / 1000) | 0)
    // '.' +
    // pad(s % 1000, 3)
  );
}
